import { render } from "./PropertiesComponent.vue?vue&type=template&id=40ff9efe&scoped=true"
import script from "./PropertiesComponent.vue?vue&type=script&lang=js"
export * from "./PropertiesComponent.vue?vue&type=script&lang=js"

import "./PropertiesComponent.vue?vue&type=style&index=0&id=40ff9efe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ff9efe"]])

export default __exports__